module.exports = __webpack_public_path__ + "static/media/retouched-evening-photo-white.38cfe234.svg";